module.exports = __webpack_public_path__ + "img/2025-09-19e_2.2df2d39d.jpg";